import { post } from '@alltrails/core/utils/post';
import type ExploreServiceResponse from '@alltrails/explore-service/types/ExploreServiceResponse';

export default async function getMapBoundsFromSlug(slug: string) {
  return post<ExploreServiceResponse<any>>(`/api/alltrails/explore/v1/search`, {
    resultsToInclude: ['boundingBox'],
    location: { slug }
  });
}
